/* 3f4eca4ad1170ab110eb1f95ac3fbe3a96055ca7
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PgReceiptInfoQueryVariables = Types.Exact<{
  tenancyCode: Types.Scalars['String'];
  orderId: Types.Scalars['String'];
}>;


export type PgReceiptInfoQuery = { __typename?: 'Query', pgReceiptInfo: { __typename?: 'PgReceiptInfo', receiptUrl: string, guide?: string | undefined } };


export const PgReceiptInfoDocument = gql`
    query PgReceiptInfo($tenancyCode: String!, $orderId: String!) {
  pgReceiptInfo(tenancyCode: $tenancyCode, orderId: $orderId) {
    receiptUrl
    guide
  }
}
    `;

/**
 * __usePgReceiptInfoQuery__
 *
 * To run a query within a React component, call `usePgReceiptInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePgReceiptInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePgReceiptInfoQuery({
 *   variables: {
 *      tenancyCode: // value for 'tenancyCode'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePgReceiptInfoQuery(baseOptions: Apollo.QueryHookOptions<PgReceiptInfoQuery, PgReceiptInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PgReceiptInfoQuery, PgReceiptInfoQueryVariables>(PgReceiptInfoDocument, options);
      }
export function usePgReceiptInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PgReceiptInfoQuery, PgReceiptInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PgReceiptInfoQuery, PgReceiptInfoQueryVariables>(PgReceiptInfoDocument, options);
        }
export type PgReceiptInfoQueryHookResult = ReturnType<typeof usePgReceiptInfoQuery>;
export type PgReceiptInfoLazyQueryHookResult = ReturnType<typeof usePgReceiptInfoLazyQuery>;
export type PgReceiptInfoQueryResult = Apollo.QueryResult<PgReceiptInfoQuery, PgReceiptInfoQueryVariables>;